<template>
  <router-view/>
</template>

<script>
export default {
  name: 'Tabungan'
}
</script>
